module.exports = __webpack_public_path__ + "img/art_no_longer_the_same.578e7f67.jpg";